import { css } from "emotion";

export const container = css`
    display: inline-table;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    padding: 15px 25px;
    background-color: #fff;
    font-size: 14px;
    line-height: 20px;
    color: #333;
    font-family: Arial, Helvetica, sans-serif;
`;

export const ul = css`
    list-style: initial;
    margin: 0 15px;
`;

export const closeIcon = css`
    font-size: 15px;
    line-height: 24px;
    text-align: center;
    width: 24px;
    height: 24px;
    position: absolute;
    right: 7px;
    top: 7px;
    border-radius: 50%;
    cursor: pointer;
    fill: #767676;
    &:hover {
        fill: #2d2d2d;
    }
`;

export const title = css`
    color: #b7b7b7;
    font-size: 26px;
    padding: 20px 0;
    margin-left: -12px;
`;